var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6 .583a.75.75 0 0 1 .75.75V5.25h3.916a.75.75 0 1 1 0 1.5H6.75v3.917a.75.75 0 1 1-1.5 0V6.75H1.333a.75.75 0 0 1 0-1.5H5.25V1.333A.75.75 0 0 1 6 .583Z",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;